import { makeStyles, Typography } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(6),
  },
  title: {
    position: 'relative',
    borderBottom: `2px solid ${theme.palette.grey[300]}`,
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
}))

type FundsShowSectionProps = {
  title: React.ReactNode
  anchor: string
}
const FundsShowSection: React.FC<FundsShowSectionProps> = ({
  title,
  anchor,
  children,
}) => {
  const classes = useStyles()
  return (
    <section className={classes.root} id={anchor}>
      {title && (
        <Typography variant="h3" gutterBottom className={classes.title}>
          {title}
        </Typography>
      )}
      {children}
    </section>
  )
}

export default FundsShowSection
